import React from 'react';

export default function PaywallBlur({
  children,
  interestSource,
  ctaLabel = 'Get Early Access — $49/mo',
  openWaitlistForm,
}) {
  return (
    <div style={{ position: 'relative' }}>
      <div style={{ filter: 'blur(3px)', pointerEvents: 'none', userSelect: 'none' }}>
        {children}
      </div>
      <div style={{
        position: 'absolute', inset: 0,
        background: 'rgba(7, 9, 15, 0.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <button
          onClick={() => openWaitlistForm?.(interestSource)}
          style={{
            padding: '8px 18px',
            background: '#e9a020',
            color: '#0b0f1c',
            border: 'none',
            borderRadius: 7,
            fontFamily: "'Fraunces', serif",
            fontSize: 12,
            fontWeight: 700,
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
        >
          {ctaLabel}
        </button>
      </div>
    </div>
  );
}
